import f from '@app/icare/db/schema/field/f'

import { entityId } from '@pkg/db/schema'
import type { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientWeightId = entityId('patientWeight')

export type PatientWeightIdType = typeof PatientWeightId.Type

export const PatientWeightRelationSchema = PatientRelation.extend({
  id: PatientWeightId.schema,
  weight: f.number().nullish(),
  date: f.date().nullish(),
})

export type PatientWeightRelation = z.infer<typeof PatientWeightRelationSchema>
